// Per-anchor role-list constants for Turbo Ops (embedded layer).
//
// `OPS_REVIEWER_ROLES` gates the Ops-role variant of `salesIntake`
// (paperwork-check / accept-hold-cancel decision) and the
// post-acceptance deal-review tabs inside the `operations` mode.
//
// Spec: docs/design/role_taxonomy.md §4 (token list) + §5.1 (umbrella
// implication map) + §6 (per-anchor module home).

/**
 * Ops-role intake reviewer + post-acceptance deal-review gate. A user
 * holding ONLY `ops_reviewer` (no admin/owner umbrella) sees the
 * Ops-role intake variant + the Ops Deals tab review surfaces but
 * not the tenant-admin / org-config tools.
 *
 * Per the §5.1 implication map: today's `admin` / `owner` /
 * `org_admin` / `org_owner` / `trainer` token holders still pass —
 * they cover everything by convention.
 */
export const OPS_REVIEWER_ROLES: string[] = [
  "ops_reviewer",
  "admin",
  "owner",
  "org_admin",
  "org_owner",
  "trainer",
  "dev",
  "platform_owner",
  "platform_admin",
  "platform_dev",
  "platform_trainer",
];
